import { useState, useEffect } from 'react';
import { apiClient } from '../../contexts/AuthContext';
import { Shield, Download, Check } from 'lucide-react';
import jsPDF from 'jspdf';

const CHECKBOXES = [
  "Je m'engage a suivre mon meal planning 7j/7.",
  "Je m'engage a realiser mon cardio maison (30-45 min) selon le protocole.",
  "Je m'engage a poster mes preuves photo/video.",
  "J'accepte les controles aleatoires du coach.",
  "Je m'engage a une discipline totale pendant les 12 semaines.",
  "Je me presente aux 4 pesees officielles (J0 / S4 / S8 / S12).",
  "J'ai compris le fonctionnement de la caution et des paliers de restitution.",
  "J'accepte la clause de disqualification.",
];

function generatePDF(actData) {
  const doc = new jsPDF();
  let y = 25;
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text("ACTE D'ENGAGEMENT", 105, y, { align: 'center' });
  y += 8;
  doc.setFontSize(12);
  doc.text('CHALLENGE TRANSFORMATION LA MEUTE', 105, y, { align: 'center' });
  y += 6;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('1er juillet - 23 septembre 2026', 105, y, { align: 'center' });
  y += 12;
  doc.setFontSize(11);
  doc.setFont('helvetica', 'bold');
  doc.text(`Participant : ${actData.user_name || 'Membre'}`, 20, y);
  y += 6;
  doc.setFont('helvetica', 'normal');
  doc.text(`Objectif : ${actData.objectif_declare === 'gras' ? 'Perte de gras' : 'Prise de muscle'}`, 20, y);
  y += 6;
  doc.text(`Caution : ${actData.caution_montant?.toLocaleString() || '20 000'} XPF`, 20, y);
  y += 10;
  doc.setDrawColor(200); doc.line(20, y, 190, y); y += 6;
  doc.setFontSize(9); doc.setFont('helvetica', 'bold');
  doc.text('ENGAGEMENTS', 20, y); y += 6;
  doc.setFont('helvetica', 'normal');
  (actData.checkboxes_labels || CHECKBOXES).forEach((cb, i) => {
    const lines = doc.splitTextToSize(`[x] ${i + 1}. ${cb}`, 165);
    lines.forEach(line => { if (y > 270) { doc.addPage(); y = 20; } doc.text(line, 22, y); y += 4.5; });
    y += 1;
  });
  y += 8; doc.line(20, y, 190, y); y += 8;
  doc.setFontSize(10); doc.setFont('helvetica', 'bold');
  const signDate = actData.signed_at ? new Date(actData.signed_at).toLocaleString('fr-FR', { timeZone: 'Pacific/Tahiti', dateStyle: 'full', timeStyle: 'short' }) : 'N/A';
  doc.text(`Signe le ${signDate} (heure de Tahiti)`, 20, y);
  y += 5;
  doc.setFontSize(8); doc.setFont('helvetica', 'normal');
  doc.text(`Version : ${actData.rules_version || 'v1-2026-07'}`, 20, y);
  return doc;
}

export function EngagementBadge({ userId, userName }) {
  const [act, setAct] = useState(null);
  const [showDetail, setShowDetail] = useState(false);

  useEffect(() => {
    if (!userId) return;
    apiClient.get('/engagement/status').then(r => {
      if (r.data?.signed) setAct(r.data.act);
    }).catch(() => {});
  }, [userId]);

  if (!act) return null;

  const signDate = new Date(act.signed_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });

  const handleDownload = (e) => {
    e.stopPropagation();
    const pdf = generatePDF(act);
    pdf.save(`acte-engagement-${userName || act.user_name || 'membre'}.pdf`);
  };

  return (
    <>
      <button
        onClick={() => setShowDetail(!showDetail)}
        className="w-full flex items-center gap-3 bg-[#2e7d32]/10 border border-[#2e7d32]/30 rounded-lg p-3 text-left hover:border-[#2e7d32]/60 transition-colors"
        data-testid="engagement-badge"
      >
        <div className="w-8 h-8 rounded-full bg-[#2e7d32]/20 flex items-center justify-center flex-shrink-0">
          <Shield className="w-4 h-4 text-[#2e7d32]" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs text-[#2e7d32] font-bold">Acte signe le {signDate}</p>
          <p className="text-[9px] text-zinc-500">Cliquer pour consulter</p>
        </div>
        <button onClick={handleDownload} className="p-1.5 text-zinc-500 hover:text-[#FF6B35]" data-testid="badge-download-pdf">
          <Download className="w-4 h-4" />
        </button>
      </button>

      {showDetail && (
        <div className="bg-[#0F0F0F] border border-[#2A2A2E] rounded-lg p-3 space-y-2 animate-fade-in">
          <p className="text-[9px] text-zinc-500 uppercase tracking-wider font-bold">Engagements signes</p>
          {(act.checkboxes_labels || CHECKBOXES).map((label, i) => (
            <div key={i} className="flex items-start gap-2">
              <Check className="w-3.5 h-3.5 text-[#2e7d32] flex-shrink-0 mt-0.5" />
              <span className="text-[10px] text-zinc-400 leading-relaxed">{label}</span>
            </div>
          ))}
          <p className="text-[8px] text-zinc-600 mt-2 pt-2 border-t border-[#2A2A2E]">
            Version : {act.rules_version} | Signature : {signDate}
          </p>
        </div>
      )}
    </>
  );
}
